import React, { useState, useEffect } from 'react';
import DataCollection from '../../shared/DataCollection';
import Patch from '../../utils/Patch.js';
import TeamCardList from './TeamCardList.js';
import { useTranslation } from 'react-i18next';
import { Fetch } from '../../utils/Utils.js';

const TextInput = ({ value, onBlur }) => {
  const [currentValue, setCurrentValue] = useState(value || '');

  return (
    <input
      type="text"
      value={currentValue}
      onChange={(e) => setCurrentValue(e.target.value)}
      onBlur={(e) => {
        if (e.target.value !== value) {
          onBlur(e);
        }
      }}
    />
  );
};

const LanguageDropdown = ({ selected, onChange }) => {
  return (
    <select value={selected || ''} onChange={onChange}>
      <option value="en-US">English</option>
      <option value="pt-BR">Português</option>
    </select>
  );
};

const RanchSelect = ({ selected, ranches, onChange }) => (
  <select value={selected || ''} onChange={onChange}>
    <option value="">—</option>
    {ranches.map(r => (
      <option key={r._id} value={r._id}>{r.name}</option>
    ))}
  </select>
);

export const ListTeams = (props) => {
  const { t } = useTranslation();
  const [refreshKey, setRefreshKey] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [ranches, setRanches] = useState([]);
  const collection = "teams";

  useEffect(() => {
    Fetch('/api/ranches', 'GET', null,
      (data) => setRanches(data || []),
      () => {}
    );
  }, []);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  const onChange = (e, field, id) => {
    const value = e.target.value;
    Patch("teams", id, field, value,
      () => {
        console.log("success");
        setRefreshKey(refreshKey => refreshKey + 1);
      },
      () => { console.log("error") },
    );
  };

  const columns = [
    {
      name: t("name"),
      selector: row => row.name,
      sortable: true,
      cell: row => <TextInput
        value={row.name}
        onBlur={(e) => onChange(e, "name", row._id)}
      />
    },
    {
      name: t("email"),
      selector: row => row.email,
      sortable: true,
      cell: row => <span>{row.email || '—'}</span>
    },
    {
      name: t("phone_number"),
      selector: row => row.phone_number,
      sortable: true,
      cell: row => <TextInput
        value={row.phone_number}
        onBlur={(e) => onChange(e, "phone_number", row._id)}
      />
    },
    {
      name: t("language"),
      selector: row => row.lang,
      sortable: true,
      cell: row => <LanguageDropdown
        selected={row.lang}
        onChange={(e) => onChange(e, "lang", row._id)}
      />
    },
    {
      name: t("ranch"),
      selector: row => row.ranch_id || '',
      cell: row => ranches.length > 1 ? (
        <RanchSelect
          selected={row.ranch_id}
          ranches={ranches}
          onChange={(e) => onChange(e, "ranch_id", row._id)}
        />
      ) : (
        <span>{ranches[0]?.name || '—'}</span>
      ),
    },
    {
      name: t("role"),
      selector: row => row.role || "messenger",
      sortable: true,
      cell: row => <span>{t(row.role || "messenger")}</span>
    },
    {
      name: t("status"),
      selector: row => row.status || "active",
      sortable: true,
      cell: row => (
        <span className={`team-status team-status-${row.status || "active"}`}>
          {t(row.status || "active")}
        </span>
      )
    },
  ];

  return (
    <>
      <DataCollection
        key={refreshKey}
        collection={collection}
        columns={columns}
        mobileComponent={(data, onRefresh) => (
          <TeamCardList data={data} onRefresh={onRefresh} ranches={ranches} />
        )}
      />
    </>
  );

}

export default ListTeams;
